export const yzcolors = {
  light: {
    // text color
    textColor: '#222B45',
    textColorDefault: '#222B45',
    textColorAccent: '#3366FF',
    textColorAlternative: '#FFFFFF',
    textColorHint: '#8F9BB3',
    textColorDisabled: '#8F9BB380',
    textColorZoo: '#6231DB',
    // primary
    primary: '#333333',
    primaryT08: '#33333314',
    primaryT16: '#33333329',
    primaryT24: '#3333333D',
    primaryT32: '#33333352',
    primaryT40: '#33333366',
    primaryT48: '#3333337A',
    primary100: '#F4F4F4',
    primary200: '#EAEAEA',
    primary300: '#C1C1C1',
    primary400: '#848484',
    primary500: '#333333',
    primary600: '#2B2525',
    primary700: '#24191B',
    primary800: '#1D1013',
    primary900: '#18090E',
    // basic
    basic: '#C1C1C1',
    basic100: '#FFFFFF',
    basic100T08: '#FFFFFF14',
    basic100T16: '#FFFFFF29',
    basic100T24: '#FFFFFF3D',
    basic100T32: '#FFFFFF52',
    basic100T40: '#FFFFFF66',
    basic100T48: '#FFFFFF7A',
    basic100T64: '#FFFFFFA3',
    basic200: '#F7F7F7',
    basic300: '#F4F4F4',
    basic400: '#EAEAEA',
    basic500: '#C1C1C1',
    basic600: '#848484',
    basic600T08: '#8F9BB314',
    basic600T16: '#8F9BB329',
    basic600T24: '#8F9BB33D',
    basic600T32: '#8F9BB352',
    basic600T40: '#8F9BB366',
    basic600T48: '#8F9BB37A',
    basic700: '#333333',
    basic800: '#2B2525',
    basic900: '#24191B',
    basic1000: '#1D1013',
    basic1100: '#18090E',
    // success
    success: '#009966',
    successT08: '#00996614',
    successT16: '#00996629',
    successT24: '#0099663D',
    successT32: '#00996652',
    successT40: '#00996666',
    successT48: '#0099667A',
    success100: '#C7F9D5',
    success200: '#92F4B7',
    success300: '#59E099',
    success400: '#30C183',
    success500: '#14AE5C',
    success600: '#008364',
    success700: '#006E5F',
    success800: '#005855',
    success900: '#004449',
    // info
    info: '#3366FF',
    infoT08: '#3366FF14',
    infoT16: '#3366FF29',
    infoT24: '#3366FF3D',
    infoT32: '#3366FF52',
    infoT40: '#3366FF66',
    infoT48: '#3366FF7A',
    info100: '#D6E4FF',
    info200: '#ADC8FF',
    info200T08: '#ADC8FF14',
    info200T16: '#ADC8FF29',
    info200T24: '#ADC8FF3D',
    info200T32: '#ADC8FF52',
    info200T40: '#ADC8FF66',
    info200T48: '#ADC8FF7A',
    info300: '#84A9FF',
    info400: '#6690FF',
    info500: '#3366FF',
    info600: '#254EDB',
    info700: '#1939B7',
    info800: '#102693',
    info900: '#091A7A',
    // warning
    warning: '#FFCC00',
    warningT08: '#FFCC0014',
    warningT16: '#FFCC0029',
    warningT24: '#FFCC003D',
    warningT32: '#FFCC0052',
    warningT40: '#FFCC0066',
    warningT48: '#FFCC007A',
    warning100: '#FFF9CC',
    warning200: '#FFF099',
    warning300: '#FFE666',
    warning400: '#FFDC3F',
    warning500: '#FFCC00',
    warning600: '#DBAA00',
    warning700: '#B78B00',
    warning800: '#936D00',
    warning900: '#7A5700',
    // danger
    danger: '#C82F2F',
    dangerT08: '#CD330014',
    dangerT16: '#CD330029',
    dangerT24: '#CD33003D',
    dangerT32: '#CD330052',
    dangerT40: '#CD330066',
    dangerT48: '#CD33007A',
    danger100: '#FCE4C9',
    danger200: '#F9C495',
    danger300: '#EF985F',
    danger400: '#E06E38',
    danger500: '#C82F2F',
    danger600: '#AF1F00',
    danger700: '#920F00',
    danger800: '#760400',
    danger900: '#610003',
    //zoo
    zooPurple: '#6231DB',
    zooPurpleT10: '#6231DB1A',
    // YCE
    neutral100: '#FFFFFF',
    neutral200: '#F9FAFB',
    neutral300: '#EEEEEE',
    neutral400: '#C1C1C1',
    neutral500: '#848484',
    neutral600: '#5C5C5C',
    neutral700: '#333333',
    blue100: '#F0F8FF',
    blue500: '#0C6DFF',
    yellow100: '#FFFAE6',
    yellow500: '#EBB700',
    yellow600: '#EB7100',
    purple500: '#8A31FF',
    purple600: '#3F1BCD',
    
    // YZ CSS Colors (prefixed with yz- to avoid conflicts)
    // Base colors
    'yz-white': '#ffffff',
    'yz-black': '#000000',
    'yz-transparent': 'transparent',
    
    // YZ Neutral colors
    'yz-neutral': '#333333',
    'yz-neutral-100': '#FFFFFF',
    'yz-neutral-200': '#F9FAFB', 
    'yz-neutral-300': '#EEEEEE',
    'yz-neutral-400': '#C1C1C1',
    'yz-neutral-500': '#848484',
    'yz-neutral-600': '#525252',
    'yz-neutral-700': '#333333',
    'yz-neutral-800': '#1F1F1F',
    'yz-neutral-900': '#000000',
    
    // YZ Success colors
    'yz-success': '#14AE5C',
    'yz-success-500': '#14AE5C',
    'yz-success-700': '#259143',
    
    // YZ Warning colors  
    'yz-warning': '#EB7100',
    'yz-warning-100': '#FFFAE6',
    'yz-warning-500': '#EB7100',
    
    // YZ Danger colors
    'yz-danger': '#C82F2F',
    'yz-danger-500': '#C82F2F', 
    'yz-danger-700': '#9C2525',
    
    // YZ Basic color palette
    'yz-green': '#1A7935',
    'yz-green-100': '#EEFCE9',
    'yz-green-500': '#1A7935',
    
    'yz-red': '#B52222',
    'yz-red-100': '#FFEBEB',
    'yz-red-500': '#B52222',
    
    'yz-blue': '#3570CA',
    'yz-blue-100': '#F0F8FF',
    'yz-blue-500': '#3570CA',
    
    'yz-yellow': '#CA6C16',
    'yz-yellow-100': '#FFF7D9',
    'yz-yellow-500': '#CA6C16',

    'yz-ascent-500': '#0C6DFF'
  }
}
